import { light_offer_extended } from "@/lib/models/light_offer_extended";
import { offer } from "@/generated";
import isSpecialCoupon from "@/lib/util/isSpecialCoupon";
import is10PercentOffCoupon from "@/lib/util/is10PercentOffCoupon";

type OfferWithClipEnd = (light_offer_extended | offer) & {
  clippable_dates?: string | string[] | null;
  ended_at?: string | Date | null;
};

/**
 * For used rewards in unclippable period or expired:
 * - Special day / 10% off offers: returns the last clippable date (clip date range end date)
 * - Other offers: returns ended_at
 */
export default function getClipEndDate(
  offer: OfferWithClipEnd,
  now: Date,
): Date {
  if (
    isSpecialCoupon(offer as light_offer_extended) ||
    is10PercentOffCoupon(offer as light_offer_extended)
  ) {
    const clippableDates = (offer as light_offer_extended).clippable_dates;
    if (Array.isArray(clippableDates) && clippableDates.length > 0) {
      return new Date(clippableDates[clippableDates.length - 1]);
    }
  }
  return new Date(offer.ended_at ?? now);
}
